export const currencySymbol = {
  ALL: "Lek", // Albanian Lek
  AFN: "؋", // Afghan Afghani
  ARS: "$", // Argentine Peso
  AWG: "ƒ", // Aruban Florin
  AUD: "$", // Australian Dollar
  AZN: "₼", // Azerbaijani Manat
  BSD: "$", // Bahamian Dollar
  BBD: "$", // Barbadian Dollar
  BYN: "Br", // Belarusian Ruble
  BZD: "BZ$", // Belize Dollar
  BMD: "$", // Bermudian Dollar
  BOB: "$b", // Bolivian Boliviano
  BAM: "KM", // Bosnia-Herzegovina Convertible Mark
  BWP: "P", // Botswana Pula
  BGN: "лв", // Bulgarian Lev
  BRL: "R$", // Brazilian Real
  BND: "$", // Brunei Dollar
  KHR: "៛", // Cambodian Riel
  BDT: "৳", // Bangladeshi Taka
  CAD: "$", // Canadian Dollar
  KYD: "$", // Cayman Islands Dollar
  CLP: "$", // Chilean Peso
  CNY: "¥", // Chinese Yuan
  COP: "$", // Colombian Peso
  CRC: "₡", // Costa Rican Colón
  HRK: "kn", // Croatian Kuna
  CUP: "₱", // Cuban Peso
  CZK: "Kč", // Czech Koruna
  DKK: "kr", // Danish Krone
  DOP: "RD$", // Dominican Peso
  XCD: "$", // East Caribbean Dollar
  EGP: "£", // Egyptian Pound
  SVC: "$", // Salvadoran Colón
  EUR: "€", // Euro
  FKP: "£", // Falkland Islands Pound
  GIP: "£", // Gibraltar Pound
  GTQ: "Q", // Guatemalan Quetzal
  GGP: "£", // Guernsey Pound
  GYD: "$", // Guyanese Dollar
  HNL: "L", // Honduran Lempira
  HKD: "$", // Hong Kong Dollar
  HUF: "Ft", // Hungarian Forint
  INR: "₹", // Indian Rupee
  IDR: "Rp", // Indonesian Rupiah
  IRR: "﷼", // Iranian Rial
  IMP: "£", // Isle of Man Pound
  ILS: "₪", // Israeli Shekel
  JMD: "J$", // Jamaican Dollar
  JPY: "¥", // Japanese Yen
  JEP: "£", // Jersey Pound
  KZT: "лв", // Kazakhstani Tenge
  KPW: "₩", // North Korean Won
  KRW: "₩", // South Korean Won
  KGS: "лв", // Kyrgyzstani Som
  LAK: "₭", // Lao Kip
  LBP: "£", // Lebanese Pound
  LRD: "$", // Liberian Dollar
  MKD: "ден", // Macedonian Denar
  MYR: "RM", // Malaysian Ringgit
  MUR: "₨", // Mauritian Rupee
  MXN: "$", // Mexican Peso
  MNT: "₮", // Mongolian Tögrög
  MZN: "MT", // Mozambican Metical
  NAD: "$", // Namibian Dollar
  ANG: "ƒ", // Netherlands Antillean Guilder
  NZD: "$", // New Zealand Dollar
  NIO: "C$", // Nicaraguan Córdoba
  NGN: "₦", // Nigerian Naira
  NOK: "kr", // Norwegian Krone
  OMR: "﷼", // Omani Rial
  PKR: "₨", // Pakistani Rupee
  PAB: "B/.", // Panamanian Balboa
  PYG: "Gs", // Paraguayan Guarani
  PEN: "S/.", // Peruvian Sol
  PHP: "₱", // Philippine Peso
  PLN: "zł", // Polish Zloty
  ZAR: "R", // South African Rand
  AED: "د.إ", // United Arab Emirates Dirham
  CHF: "Fr.", // Swiss Franc
  GBP: "£", // British Pound Sterling
  RUB: "₽", // Russian Ruble
  SEK: "kr", // Swedish Krona
  TRY: "₺", // Turkish Lira
  USD: "$", // United States Dollar
  VND: "₫", // Vietnamese Dong
  ZWL: "Z$", // Zimbabwean Dollar - obsolete
  BTN: "Nu.", // Bhutanese Ngultrum
  BYR: "Br", // Belarusian Ruble (old)
  CVE: "€", // Cape Verdean Escudo
  DJF: "Fdj", // Djiboutian Franc
  DZD: "دج", // Algerian Dinar
  ERN: "Nfk", // Eritrean Nakfa
  FJD: "$", // Fijian Dollar
  GEL: "₾", // Georgian Lari
  GHS: "¢", // Ghanaian Cedi
  ISK: "kr", // Icelandic Krona
  KWD: "د.ك", // Kuwaiti Dinar
  LKR: "₨", // Sri Lankan Rupee
  LYD: "ل.د", // Libyan Dinar
  MDL: "L", // Moldovan Leu
  MVR: "ރ", // Maldivian Rufiyaa
  MWK: "MK", // Malawian Kwacha
  NPR: "₨", // Nepalese Rupee
  RSD: "din.", // Serbian Dinar
  SAR: "ر.س", // Saudi Riyal
  SCR: "₨", // Seychellois Rupee
  SYP: "£", // Syrian Pound
  TND: "د.ت", // Tunisian Dinar
  TTD: "TT$", // Trinidad and Tobago Dollar
  TWD: "NT$", // New Taiwan Dollar
  UGX: "Ush", // Ugandan Shilling
  YER: "﷼", // Yemeni Rial
  ZMW: "K", // Zambian Kwacha
  XOF: "CFA", // West African CFA Franc
  XAF: "FCFA", // Central African CFA Franc
  TZS: "TSh", // Tanzanian Shilling
  SZL: "L", // Swazi Lilangeni
  STN: "Db", // São Tomé and Príncipe Dobra
  SSP: "£", // South Sudanese Pound
  SOS: "Sh.So.", // Somali Shilling
  SLL: "Le", // Sierra Leonean Leone
  ETB: "ብር", // Ethiopian Birr
  MMK: "Ks.", // Myanmar Kyat
  BLANK: "", // to not curreny symbol
};

export function getCurrencySymbol(currencyCode, sendCodeBack = true) {
  return (
    currencySymbol[currencyCode] ?? (sendCodeBack ? currencyCode : undefined)
  );
}
